import React from "react"

import {
    CheckoutRootContainer,
    CheckoutLeftContainer,
    CheckoutRightContainer,
} from "~components/pages/listing/checkout/checkout-layout-components"
import CheckoutFlowNavButtons from "~components/pages/listing/checkout/checkout-flow/checkout-flow-nav-buttons"
import WidgetPersonalInfoForm from "~widget/components/widget-checkout-flow/widget-personal-info-form"
import useLogInAsGuestUser from "~utils/useLogInAsGuestUser"
import { useCheckoutFlow } from "~components/pages/listing/checkout/checkout-flow/checkout-flow-provider"
import Form from "~components/shared/hook-form/core/form"
import { FORM_MODES } from "~config/constants"
import { useSchema } from "~components/pages/listing/checkout/continue-as-guest-form/continue-as-guest-form-helpers"
import CheckoutSummaryDrawer from "~components/pages/listing/checkout/checkout-summary-drawer"
import CheckoutFlowSummaryContent from "~components/pages/listing/checkout/checkout-flow/checkout-flow-summary-content"
import BookingBreadcrumbs from "~components/pages/book/booking-breadcrumbs"

export default function WidgetCheckoutFlowInfoStep() {
    const { goToNextStep, listing, quote } = useCheckoutFlow()
    const { logInAsGuestUser, isLoading } = useLogInAsGuestUser({
        onSuccess: goToNextStep,
    })
    const schema = useSchema()
    const renderNavButtons = () => (
        <CheckoutFlowNavButtons
            isContinueButtonFormSubmit
            isLoading={isLoading}
        />
    )

    // For typescript. We will always have a listing here.
    if (!listing) return null

    return (
        <Form mode={FORM_MODES.ALL} schema={schema} onSubmit={logInAsGuestUser}>
            <CheckoutRootContainer isWidget>
                <CheckoutLeftContainer isWidget>
                    <BookingBreadcrumbs listingId={listing.id} />
                    <WidgetPersonalInfoForm />
                </CheckoutLeftContainer>
                <CheckoutRightContainer isWidget>
                    <CheckoutFlowSummaryContent
                        listing={listing}
                        quote={quote}
                        renderNavButtons={renderNavButtons}
                    />
                </CheckoutRightContainer>
            </CheckoutRootContainer>
            <CheckoutSummaryDrawer
                quote={quote}
                listing={listing}
                renderNavButtons={renderNavButtons}
            />
        </Form>
    )
}
